import { render, staticRenderFns } from "./ContactSupportPage.vue?vue&type=template&id=b8670732&scoped=true"
import script from "./ContactSupportPage.vue?vue&type=script&lang=ts"
export * from "./ContactSupportPage.vue?vue&type=script&lang=ts"
import style0 from "./ContactSupportPage.vue?vue&type=style&index=0&id=b8670732&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8670732",
  null
  
)

export default component.exports